import React from 'react';
// Data
import { tourDataArray } from '../../utils/data/TourData';
import { CONTACT_PAGE_URL } from '../../utils/Routes';
import { Link } from 'react-router-dom';

function TourPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full pb-12 pt-12'>
      {/* Form section */}
      <section className='grid w-full'>
        <div className='grid w-full px-6 lg:container lg:mx-auto'>
          <section className='grid px-8 mx-auto py-8 gap-y-4 w-full min-w-xl max-w-3xl'>
            {/* Sexy Intro Text */}
            <div className='text-sm lg:text-base leading-relaxed space-y-4 text-center'>
              <p className='text-5xl lg:text-6xl font-titleFont text-colour6'>
                Get ready to meet the irresistible Mistress Maria in a city near
                you...
              </p>
              <p>
                Whether you're seeking strict discipline, sensual dominance, or
                complete submission, I bring my unique brand of kinky fun
                wherever I go.
              </p>
              <p>
                While I’m usually based in <strong>Central Norfolk</strong> (NR1
                / NR2) with a selection of private, discreet venues, I’m also
                available to travel — just cover my costs, and I’ll bring the
                fantasy to you.
              </p>
              <p>
                Check below to see where I’ll be touring, and don’t miss your
                chance to serve, obey, and indulge.
              </p>
            </div>

            <div className='neon_line my-4' />

            <div className='text-center'>Coming Soon</div>
            {/* Tour Listings (commented out) */}
          </section>

          {/* Tribute Rates Section */}
          <section className='grid w-full px-6 pt-12'>
            <div className='grid px-8 mx-auto py-8 gap-y-4 w-full min-w-xl max-w-3xl text-center text-colour2'>
              <h3 className='text-4xl lg:text-5xl font-titleFont text-colour6 font-semibold'>
                Tribute Rates
              </h3>
              <p className='text-sm lg:text-base leading-relaxed'>
                Sessions start from just <strong>£175</strong>. Tribute rates
                vary depending on the type, length, and intensity of the
                session, as well as any special requests.
              </p>
              <p className='text-sm lg:text-base leading-relaxed'>
                Contact me directly to discuss your ideal session and receive a
                personalized quote.
              </p>
              <div className='grid w-fit mx-auto mt-4'>
                <Link
                  to={CONTACT_PAGE_URL}
                  className='bg-colour6 hover:brightness-110 text-colour1 text-sm font-serif px-6 py-2 border-2 border-colour2 uppercase'
                  aria-label='Enquire about tribute rates with Mistress Maria'
                  title='Enquire about tribute rates with Mistress Maria'
                >
                  Contact Me
                </Link>
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* Small FMTY Section */}
      <section className='grid w-full px-6 pt-12'>
        <div className='grid px-8 mx-auto py-8 gap-y-4 w-full min-w-xl max-w-3xl text-center text-colour2'>
          <h3 className='text-4xl lg:text-5xl font-titleFont text-colour6 font-semibold'>
            Fly Me To You
          </h3>
          <p className='text-sm lg:text-base leading-relaxed'>
            Want to see me somewhere not on the tour list? I may travel directly
            to you for exclusive sessions — just cover all travel expenses and
            arrange a deposit.
          </p>
          <p className='text-sm lg:text-base leading-relaxed'>
            Advance notice required. Sessions are tailored, discreet, and
            unforgettable.
          </p>
          <div className='grid w-fit mx-auto mt-4'>
            <Link
              to={CONTACT_PAGE_URL}
              className='bg-colour6 hover:brightness-110 text-colour1 text-sm font-serif px-6 py-2 border-2 border-colour2 uppercase'
              aria-label='Enquire about Fly Me To You sessions with Mistress Maria'
              title='Enquire about Fly Me To You sessions with Mistress Maria'
            >
              Contact Me
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default TourPageMainContainer;
